import { Component, Input } from "@angular/core";
import { PlanungApiOverviewComponent } from "../../planung-api-overview.component";
import { addMonths } from "date-fns";

@Component({
    selector: "app-planung-scheduler-dayview",
    templateUrl: "./custom-day-view.component.html",
    styleUrls: ["./custom-day-view.component.scss"],
    standalone: false
})
export class PlanungApiSchedulerCustomDayViewComponent {
  public showDatePopUp = false;
  public calendarOffset: { top: number; left: number } = null;

  @Input() overview: PlanungApiOverviewComponent = null;

  public ToggleCalendarPopup(ev: MouseEvent) {
    this.showDatePopUp = !this.showDatePopUp;
    if (this.showDatePopUp) {
      if (ev.target) {
        const target = ev.target as HTMLElement;
        const rect = target.getBoundingClientRect();
        this.calendarOffset = { left: rect.left, top: rect.top + rect.height };
      } else {
        this.calendarOffset = { left: ev.x, top: ev.y };
      }
    }
  }
  public SetReferenceDateToToday() {
    this.overview.uiState.ReferenceDate = new Date();
  }
  public SetReferenceDateToPrevious() {
    this.overview.uiState.ReferenceDate = addMonths(
      this.overview.uiState.ReferenceDate,
      -1
    );
  }
  public SetReferenceDateToNext() {
    this.overview.uiState.ReferenceDate = addMonths(
      this.overview.uiState.ReferenceDate,
      1
    );
  }

  private _GetRect(ele: HTMLElement) {
    const result = { top: 0, left: 0, height: 0, width: 0,};
    let curr = ele;
    result.height = ele.offsetHeight;
    while (curr) {
        result.top += curr.offsetTop;
        result.left += curr.offsetLeft;
        curr = curr.offsetParent as HTMLElement;
    }
    return result;
  }
}
